import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/list-duck";
import { IUnidade } from "interfaces/unidade";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess"],
    success: ["data", "pagination"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "LIST_UNIDADES_TAGS" }
);

export interface ListUnidadesTags extends IState {
  data: IUnidade[];
}

interface ISuccessListUnitsAction extends ISuccessAction {
  data: IUnidade[];
}

const INITIAL_STATE: ListUnidadesTags = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: ListUnidadesTags) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: ListUnidadesTags, action: ISuccessListUnitsAction) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ListUnidadesTags, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const listUnidadesTags = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ListUnidadesTagsTypes = Types;
export const ListUnidadesTagsActions = Creators;
